module.exports = __webpack_public_path__ + "img/first.307eafee.png";